import React, { useContext } from 'react';
import sanitizeHtml from 'sanitize-html-react';

import {
  useRewardShopBannerContent,
  RewardShopBanner,
} from '@zooplus/bonus-points-library/reward-shop-banner';
import { Domain, Locale } from '@zooplus/commons-lang';

import defaultBanner from '../assets/img/banners/reward-shop-icon-700-x-220-int.png';
import biggerDefaultBanner from '../assets/img/banners/reward-shop-icon-700-x-220-int@2x.png';
import LocResourcesContext, { LocResourcesContextProps } from '../contexts/LocResourcesContext';
import { View } from '../utils/types';

const GLOBAL_PREFIX = 'loy-bppo-bannerContainer';

interface BannerProps {
  siteDomain: Domain;
  locale: Locale;
  view: View;
  defaultTitle: string;
  defaultSubtitle: string;
  bannerName: string;
  showNewSimplifiedBanner: boolean;
}

export default function Banner({
  view,
  defaultTitle,
  defaultSubtitle,
  showNewSimplifiedBanner,
}: BannerProps) {
  const { onFormatLocale } = useContext(LocResourcesContext) as LocResourcesContextProps;
  const { data: bannerContent, isLoading: bannerContentIsLoading } =
    useRewardShopBannerContent(view);

  function defaultHeader() {
    if (showNewSimplifiedBanner) {
      return (
        <header className={`${GLOBAL_PREFIX}__title`}>
          <h1>{onFormatLocale?.('mzp.overview.bonus-program.view-reward-shop')}</h1>
        </header>
      );
    } else {
      return (
        <header className={GLOBAL_PREFIX}>
          <div className={`${GLOBAL_PREFIX}__content`}>
            <h1>{onFormatLocale?.(defaultTitle)}</h1>
            <p>
              <span
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(onFormatLocale?.(defaultSubtitle)),
                }}
              />
            </p>
          </div>
          <div className={`${GLOBAL_PREFIX}__image`}>
            <img
              src={defaultBanner}
              srcSet={defaultBanner + ' 1x,' + biggerDefaultBanner + ' 2x'}
              alt=""
              aria-hidden
            />
          </div>
        </header>
      );
    }
  }

  function getHeader() {
    return (
      <header className={GLOBAL_PREFIX}>
        <RewardShopBanner view={view} id="custom-banner" className={`${GLOBAL_PREFIX}__image`} />
      </header>
    );
  }

  if (bannerContentIsLoading) {
    return null;
  }

  if (bannerContent === undefined) {
    return defaultHeader();
  } else {
    return getHeader();
  }
}
